import StateType, { ClientType } from './state.type';

export default {
  loading: false,
  emailSent: false,
  client: {} as ClientType,
} as StateType;
